/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateScriptRequest
 */
export interface CreateScriptRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScriptRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateScriptRequest interface.
 */
export function instanceOfCreateScriptRequest(value: object): boolean {
    return true;
}

export function CreateScriptRequestFromJSON(json: any): CreateScriptRequest {
    return CreateScriptRequestFromJSONTyped(json, false);
}

export function CreateScriptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScriptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateScriptRequestToJSON(value?: CreateScriptRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

